module.exports = __webpack_public_path__ + "static/media/galeryFloating3.c54b113b.jpg";